var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4288 3.6664H9.5712M4.4288 3.6664C4.4288 2.1944 5.58 1 7 1C8.42 1 9.5712 2.1936 9.5712 3.6664M4.4288 3.6664C2.5352 3.6664 1 5.2584 1 7.2224V15.7552C1 16.4432 1.768 17 2.7144 17H11.2856C12.2328 17 13 16.4432 13 15.7552V7.2224C13 5.2584 11.4648 3.6664 9.5712 3.6664M5.7144 9H8.2856C8.996 9 9.5712 8.4032 9.5712 7.6664C9.5712 6.9304 8.9952 6.3336 8.2856 6.3336H5.7144C5.004 6.3336 4.4288 6.9304 4.4288 7.6664C4.4288 8.4024 5.0048 9 5.7144 9ZM9.5712 17V13.4448C9.5712 12.4624 8.8032 11.6664 7.8568 11.6664H6.144C5.1968 11.6664 4.4296 12.4624 4.4296 13.4448V17H9.5712Z",
    stroke: "#12234F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 16,
    r: 4,
    fill: "#008234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3875 16.7875L14.5062 14.6688C14.5562 14.6188 14.6146 14.5938 14.6812 14.5938C14.7479 14.5938 14.8062 14.6188 14.8562 14.6688C14.9062 14.7188 14.9312 14.7782 14.9312 14.847C14.9312 14.9158 14.9062 14.9752 14.8562 15.025L12.5625 17.325C12.5125 17.375 12.4542 17.4 12.3875 17.4C12.3208 17.4 12.2625 17.375 12.2125 17.325L11.1375 16.25C11.0875 16.2 11.0635 16.1407 11.0655 16.072C11.0675 16.0033 11.0936 15.9439 11.1437 15.8937C11.1939 15.8436 11.2533 15.8186 11.322 15.8187C11.3907 15.8189 11.45 15.8439 11.5 15.8937L12.3875 16.7875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.bec8285d7ff95fa16eb39dad1e91dc20.svg";
export { ForwardRef as ReactComponent };